import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Reveal } from "./Brand";
import { API, money, scrollToId } from "../lib/site";

const Card = ({ t, featured, i }) => (
  <motion.article data-testid="supporter-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: (i % 3) * 0.08 }} whileHover={{ y: -4 }}
    className={`rounded-3xl border border-[#f4ede2]/10 bg-[#1c1824] p-7 flex flex-col justify-between min-h-[200px] hover:border-[#e3ba73]/40 transition-colors duration-300 ${featured ? "md:col-span-2 md:row-span-2 bg-[#241c2b]" : ""}`}>
    <p className={`font-serif-d text-[#f4ede2] leading-snug ${featured ? "text-3xl sm:text-4xl italic" : "text-xl"}`}>
      {t.message ? `“${t.message}”` : "Left a tip without a word — sometimes that says enough."}
    </p>
    <div className="mt-8 flex items-center justify-between">
      <span className="text-sm text-[#c4bbb0]">{t.name}</span>
      <span className="font-mono-d text-xs rounded-full border border-[#e3ba73]/40 text-[#e3ba73] px-3 py-1">{money(t.amount)}</span>
    </div>
  </motion.article>
);

export const Wall = () => {
  const [data, setData] = useState({ items: [], supporters: 0 });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/wall`)
      .then((r) => setData({ items: Array.isArray(r.data?.items) ? r.data.items : [], supporters: r.data?.supporters ?? 0 }))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <section id="wall" data-testid="supporter-wall-section" className="py-28 sm:py-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <Reveal><p className="overline mb-6">Reader notes</p></Reveal>
            <Reveal delay={0.1}><h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl tracking-tight">Words from the people<br className="hidden sm:block" /> who keep me writing.</h2></Reveal>
          </div>
          <Reveal delay={0.2}>
            <p data-testid="supporter-count" className="font-serif-d text-6xl text-[#e3ba73] leading-none">{data.supporters}
              <span className="block mt-2 font-mono-d text-[11px] tracking-[0.3em] uppercase text-[#c4bbb0]">readers have tipped</span>
            </p>
          </Reveal>
        </div>
        {loaded && data.items.length === 0 ? (
          <Reveal>
            <div data-testid="wall-empty" className="rounded-3xl border border-dashed border-[#e3ba73]/30 p-10 sm:p-16 text-center">
              <p className="font-serif-d text-3xl sm:text-4xl italic">The first page is still blank.</p>
              <p className="mt-4 text-[#c4bbb0]">Be the first reader to leave a note.</p>
              <button data-testid="wall-tip-button" onClick={() => scrollToId("tip")} className="mt-8 rounded-full bg-[#e3ba73] text-[#121016] px-7 py-3 font-semibold hover:bg-[#f4d79e] transition-colors duration-300">Leave a tip</button>
            </div>
          </Reveal>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[minmax(200px,auto)] gap-5">
            {data.items.map((t, i) => <Card key={t.id} t={t} i={i} featured={i === 0 && data.items.length > 2} />)}
          </div>
        )}
      </div>
    </section>
  );
};
